import React from 'react'
import numberHelper from '../../util/numberFormatter'
import dateHelper from '../../util/dateFormatter'
import { Link } from 'react-router-dom';

const TradeList = props => {
  if (!props.trades) {
    return (
      <div className='broad'>Loading...</div>
    );
  }

  if (props.trades.length === 0) {
    return (
      <div className='empty'>
        No trades...
      </div>
    );
  }

  return (
    <div>
      <table className="dataTable">
        <thead>
          <tr>
            <th>Key</th>
            <th>Time</th>
            <th>Type</th>
            <th>Amount</th>
            <th>Unit Price</th>
            <th>Status</th>
          </tr>
        </thead>
        <tbody>
          {
            props.trades.map(trade => {
              return (
                <tr key={trade.key}>
                  <td className="keyfield"><Link to={`/trade/detail/${trade.key}`}>{trade.key}</Link></td>
                  <td>{dateHelper.Formatter.toLocalString(trade.modified)}</td>
                  <td>{trade.type}</td>
                  <td>{numberHelper.Formatter.toDecimal(trade.amount)}</td>
                  <td>{numberHelper.Formatter.toCurrency(trade.unit_price)}</td>
                  <td>{trade.status}</td>
                </tr>
              )
            })
          }
        </tbody>
      </table>
    </div>
  );
};

export default TradeList;



// WEBPACK FOOTER //
// ./src/components/widgets/TradeList.js